import { lazy, Suspense } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { IntlProvider } from 'react-intl';
import ClientOnly from 'components/ClientOnly';
import { getMessages } from 'localization';
import ErrorBoundary from './app/components/ErrorBoundary';

// The app reads auth and settings from localStorage while rendering, so it only renders in the
// browser until auth moves to the server (phase 3 in plans/feature-ETU-78961_ssr.md). Loading it
// lazily keeps the server from evaluating the app's modules at all. In the browser the import
// starts as soon as this module loads, instead of after hydration.
const loadApp = () => import('app');
if (typeof window !== 'undefined') loadApp();
const AppRoot = lazy(loadApp);

const messages = getMessages();
const errorFunction = () => '';

// The ErrorBoundary lives here rather than in root.tsx: errors thrown below a route are caught by
// that route's boundary first, so one in root.tsx would never see them.
const CatchAll = () => (
  <NuqsAdapter>
    <IntlProvider locale="sv" messages={messages} onError={errorFunction}>
      <ErrorBoundary>
        <ClientOnly>
          <Suspense fallback={null}>
            <AppRoot />
          </Suspense>
        </ClientOnly>
      </ErrorBoundary>
    </IntlProvider>
  </NuqsAdapter>
);

export default CatchAll;
